import Vue from "vue";
import Vuex from "vuex";
import API from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    transliterateData: {
      original: "",
      result: "",
      inputScript: "cyrillic",
      outputScript: "arabic",
      language: "kazakh"
    }
  },
  getters: {
    transliterateData: state => state.transliterateData
  },
  mutations: {
    UPDATE_RESULT(state, result) {
      state.transliterateData.result = result;
    }
  },
  actions: {
    convert({ commit }, toConvert) {
      commit("UPDATE_RESULT", "");
      API.convert(toConvert).then(response => {
        commit("UPDATE_RESULT", response.data.result_text);
      });
    }
  }
});
